import React from 'react';
import { withImageOptimizerBySizeAndType } from 'Utils/Content';

const SOURCE_BY_BREAKPOINTS_MAP = {
  481: 'portraitHandset',
  767: 'portraitHandset',
  900: 'portraitTablet',
  1150: 'portraitTablet',
  1270: 'portraitTablet',
  1400: 'portraitTablet',
  1450: 'defaultImage',
  1919: 'defaultImage',
};

function getMediaSize(size) {
  return `(max-width: ${size}px)`;
}

export function ImageContent({ image, type, className = '', alt }) {
  if (!image) {
    return null;
  }

  const { defaultImage } = image;
  const getImageUrl = (key) => {
    return (image[key] && image[key].url) || null;
  };

  return (
    <div className={`imageContent ${className}`}>
      <picture className="pictureWrapper">
        {Object.keys(SOURCE_BY_BREAKPOINTS_MAP)
          .map((breakpoint) => {
            const src = getImageUrl(SOURCE_BY_BREAKPOINTS_MAP[breakpoint]);
            if (src) {
              return (
                <source
                  key={breakpoint}
                  media={getMediaSize(breakpoint)}
                  width={breakpoint}
                  height="1"
                  srcSet={withImageOptimizerBySizeAndType(src, breakpoint, type)}
                />
              );
            }
            return null;
          })
          .filter((picture) => picture)}
        <img className="heroImage" src={defaultImage.url} alt={alt || defaultImage.url} />
      </picture>
    </div>
  );
}
